// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IBusinessEntityTypeDto
 */
export interface IBusinessEntityTypeDto {
    /**
     * 
     * @type {number}
     * @memberof IBusinessEntityTypeDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IBusinessEntityTypeDto
     */
    name?: string;
}

/**
 * Check if a given object implements the IBusinessEntityTypeDto interface.
 */
export function instanceOfIBusinessEntityTypeDto(value: object): value is IBusinessEntityTypeDto {
    return true;
}

export function IBusinessEntityTypeDtoFromJSON(json: any): IBusinessEntityTypeDto {
    return IBusinessEntityTypeDtoFromJSONTyped(json, false);
}

export function IBusinessEntityTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IBusinessEntityTypeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function IBusinessEntityTypeDtoToJSON(json: any): IBusinessEntityTypeDto {
    return IBusinessEntityTypeDtoToJSONTyped(json, false);
}

export function IBusinessEntityTypeDtoToJSONTyped(value?: IBusinessEntityTypeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

